import { render, staticRenderFns } from "./CalendarDetails.vue?vue&type=template&id=ab50e902&scoped=true&"
import script from "./CalendarDetails.vue?vue&type=script&lang=js&"
export * from "./CalendarDetails.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDetails.vue?vue&type=style&index=0&id=ab50e902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab50e902",
  null
  
)

export default component.exports